import React from 'react';
import { httpClient, uploadClient } from "util/Api";
import { config } from "util/config";
import AntDraggableModal from 'components/AntDraggableModal';
import { message, Space, Table, Pagination, Tag, Empty, Row, Col, Form, Input, Divider, Tooltip, Button, Popconfirm, Select, Upload, Progress, Modal } from 'antd';
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import * as globalFunction from 'util/GlobalFunction';
import * as imageConversion from 'image-conversion';
import * as document from 'components/UIBuilder/SectionFunction/Document';

export default class UploadDocument extends React.Component {
  constructor(props) {
    super();
    this.state = {
      submitting: false,
      DocumentTypeId: null,
      fileList: [],
      componentDataSource: [],
      componentDefaultValue: [],
      onDragEnterCLass: ''
    }

    this.formRef = React.createRef();
  }

  async uploadDocumentSubmit() {
    if (this.state.fileList.length > 0) {
      this.setState({ submitting: true });
      let documentIds = [];
      const res = this.state.fileList.map(async (file) => {
        if (file.status === undefined) {
          let formData = new FormData();
          formData.append('jobId', this.props.jobId);
          formData.append('AccessCode', this.props.accessCode);
          if (this.props.pageComponent.state.jobChecklistId !== 0 && this.props.pageComponent.state.jobChecklistId !== undefined) {
            formData.append('jobChecklistId', this.props.pageComponent.state.jobChecklistId);
            formData.append('DocumentTypeName', 'JobChecklistClientDocument');
          }
          if (this.props.pageComponent.state.jobRequiredCertificateId !== 0 && this.props.pageComponent.state.jobRequiredCertificateId !== undefined) {
            formData.append('jobRequiredCertificateId', this.props.pageComponent.state.jobRequiredCertificateId);
            formData.append('DocumentTypeName', 'JobRequiredCertificateClientDocument');
          }

          let currentFile = file;
          if (config.imageTypes.indexOf(file.type) >= 0 && file.size > 1024 * config.uploadImageMaxLength) {
            currentFile = await imageConversion.compressAccurately(file, {
              size: config.uploadImageMaxLength,
              accuracy: '',
              type: '',
              width: '',
              height: '',
              scale: '1',
              orientation: ''
            });
            currentFile.name = file.name;
          }
          formData.append('files[]', currentFile);
          formData.append('Name', file.name);

          if (file.DocumentTypeId !== undefined && file.DocumentTypeId !== null) {
            formData.append('DocumentTypeId', file.DocumentTypeId);
          }
          if (file.Comment !== undefined && file.Comment !== null) {
            formData.append('Comment', file.Comment);
          }

          let that = this;
          await uploadClient
            .post(this.props.uploadUrl, formData, {
              onUploadProgress: (progressEvent) => {
                const uploadProgress = (progressEvent.loaded / progressEvent.total) * 100;
                let fileList = this.state.fileList.map((oldFile, i) => {
                  if (oldFile.name === file.name && oldFile.size === file.size) {
                    oldFile.percent = uploadProgress;
                    if (oldFile.percent == 100) {
                      oldFile.status = 'done';
                    } else {
                      oldFile.status = 'uploading';
                    }
                  }
                  return oldFile;
                })
                this.setState({ fileList });
              },
            })
            .then(({ data }) => {
              if (data.result) {
                documentIds.push(data.data);
                return true;
              } else {
                let fileList = that.state.fileList.map((oldFile, i) => {
                  if (oldFile.name === file.name && oldFile.size === file.size) {
                    oldFile.status = 'error';
                  }
                  return oldFile;
                })
                this.setState({ fileList });
                message.error(file.name + ' not upload, ' + data.message);
              }
            })
            .catch(function (error) {
              let fileList = that.state.fileList.map((oldFile, i) => {
                if (oldFile.name === file.name && oldFile.size === file.size) {
                  oldFile.status = 'error';
                }
                return oldFile;
              })
              that.setState({ fileList });
              message.error(file.name + ' not upload, ' + error.message);
            });
        }
      })
      await Promise.all(res);

      Modal.confirm({
        icon: <div className="icon-title-wrapper">
        <img className="svg-img-btn" src={'assets/images/icon/verified_green.svg'} />
        <span className="title-text">Document Upload Successful</span>
         </div>,
        content: <span style={{marginLeft: '25px'}}>They will be reviewed by our team</span>,
        okText: 'OK',
        cancelButtonProps: { style: { display: 'none' } },
        onOk: () => {

          this.props.component.getSectionDataByDefault();

          //这里处理不同的uploadType的后续操作
          switch (this.props.pageComponent.state.uploadType) {
            case 'JobChecklistClientDocument':
              let jobChecklistSection = globalFunction.getSectionComponent(this.props.pageComponent, 'JobChecklist');
              jobChecklistSection.getSectionDataByDefault();
              break;
            case 'JobRequiredCertificateClientDocument':
              let jobRequiredCertificateSection = globalFunction.getSectionComponent(this.props.pageComponent, 'JobRequiredCertificate');
              jobRequiredCertificateSection.getSectionDataByDefault();
              break;
          }
          this.closeUploadModal();
          if (this.props.accessCode === undefined) {
            let parameter = {};
            parameter.JobId = this.props.jobId;
            parameter.DocumentIdList = documentIds;
            this.sendClientDocumentUploadNotification(parameter);
          } else {
            let parameter = {};
            parameter.accessCode = this.props.accessCode;
            parameter.DocumentIdList = documentIds;
            this.publicSendClientDocumentUploadNotification(parameter);
          }
        },
      });
    } else {
      this.closeUploadModal();
    }
  }

  sendClientDocumentUploadNotification(parameter) {
    let that = this;
    httpClient
      .post('/Business/Document/SendClientDocumentUploadNotification', parameter)
      .then(({ data }) => {
      })
      .catch(function (error) {
      });
  }

  publicSendClientDocumentUploadNotification(parameter) {
    let that = this;
    httpClient
      .post('/Business/Document/PublicSendClientDocumentUploadNotification', parameter)
      .then(({ data }) => {
      })
      .catch(function (error) {
      });
  }

  closeUploadModal() {
    this.props.pageComponent.setState({ uploadType: '', jobChecklistId: 0 });
    this.formRef.current?.setFieldValue('DocumentTypeId', this.state.componentDataSource?.DocumentTypeId?.[0]?.Value);

    this.setState({
      fileList: [],
      submitting: false
    });
    setTimeout(() => {
      this.props.component.setState({
        uploadDocumentShow: false
      });
    }, config.setTimeoutMilliSecond * 50);
  }

  removeFile(file) {
    const index = this.state.fileList.indexOf(file);
    const newFileList = this.state.fileList.slice();
    newFileList.splice(index, 1);
    this.setState({ fileList: newFileList });
  }

  render() {
    return (
      <AntDraggableModal
        title="Upload Document"
        className='upload-drag-modal'
        open={this.props.component.state.uploadDocumentShow}
        onOk={() => this.uploadDocumentSubmit()}
        onCancel={() => {
          this.closeUploadModal();
        }}
        width={1100}
        maskClosable={config.component.Modal.maskClosable}
        footer={[
          <Button key="back" onClick={() => this.closeUploadModal()}>
            Cancel
          </Button>,
          <Button key="submit" type="primary" loading={this.state.submitting} onClick={() => this.uploadDocumentSubmit()}>
            Upload
          </Button>,
          <span key="Controls" style={{ width: '100%' }}>
            <Form
              ref={this.formRef}
              autoComplete="off"
              size={config.component.size}
              className="clear-margin-form clear-padding-form"
            >
              {
                this.state.componentDataSource.DocumentTypeId != undefined ?
                  <Form.Item
                    label=""
                    labelCol={0}
                    wrapperCol={24}
                    name="DocumentTypeId"
                    style={{ width: '200px' }}
                    className="footer-control"
                  >
                    <Select
                      key="DocumentTypeId"
                      className="filter-select"
                      bordered={config.component.bordered}
                      id="DocumentTypeId"
                      size={config.component.size}
                      showSearch
                      filterOption={(inputValue, option) => {
                        return option?.children?.toLowerCase().includes(inputValue.toLowerCase())
                      }}
                      onChange={(value) => {
                        this.setState({ DocumentTypeId: value });
                      }}
                    >
                      {
                        this.state.componentDataSource.DocumentTypeId.map(option => <Select.Option style={{ color: option.Color }} key={option.Value} value={option.Value}>{option.Key}</Select.Option>)
                      }
                    </Select>
                  </Form.Item> : <span key="DocumentTypeId"></span>
              }
            </Form>
          </span>
        ]}
      >
        <div
          className={'upload-drag-div ' + this.state.onDragEnterCLass}
          style={{ padding: '24px' }}
          onDragEnter={() => { this.setState({ onDragEnterCLass: 'onDragEnter' }) }}
          onDragLeave={() => { this.setState({ onDragEnterCLass: '' }) }}
          onDragOver={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
          onDrop={(e) => {
            e.preventDefault();
            e.stopPropagation();
            document.dropDocument({ e: e, component: this });
          }}>
          <Upload
            name="file"
            style={{ width: '100%' }}
            multiple={true}
            fileList={this.state.fileList}
            onRemove={(file) => {
              this.removeFile(file);
            }}
            beforeUpload={(file) => {
              let fileList = this.state.fileList;
              file.DocumentTypeId = this.formRef.current?.getFieldValue('DocumentTypeId');
              if (file.size / 1024 / 1024 > config.fileUploadLimit) {
                file.status = 'error';
                file.tip = file.name + ' size larger than ' + config.fileUploadLimit + 'M';
              }
              if (file.size === 0) {
                file.status = 'error';
                file.tip = file.name + ' - This file is 0KB and will not be uploaded. Make sure not to select or drag files from a zipped file/folder.';
              }
              fileList.push(file);
              this.setState({ fileList });
              return false;
            }}
            itemRender={(originNode, file, currFileList) => (
              <>{
                file.status !== 'error' ?
                  <div className='upload-container'>
                    <div className="ant-upload-list-item-info">
                      <span className="ant-upload-span" style={{ marginBottom: '4px' }}>
                        <span className="ant-upload-list-item-name" title={file.name}>{file.name} ({globalFunction.formatFileSize(file.size)})</span>
                        <span className="ant-upload-list-item-card-actions">
                          <Tooltip title="Delete">
                            <Button
                              className="upload-delete-icon"
                              icon={<img className="svg-img-btn" src={'assets/images/icon/delete.svg'} />}
                              type='link'
                              onClick={() => {
                                this.removeFile(file);
                              }}
                            />
                          </Tooltip >
                        </span>
                      </span>
                      <span className="ant-upload-span">
                        {
                          this.state.componentDataSource.DocumentTypeId != undefined ? <Select
                            defaultValue={this.formRef.current?.getFieldValue('DocumentTypeId')}
                            className="filter-select footer-control"
                            bordered={config.component.bordered}
                            size={config.component.size}
                            showSearch
                            filterOption={(inputValue, option) => {
                              return option?.children?.toLowerCase().includes(inputValue.toLowerCase())
                            }}
                            onChange={(value) => {
                              let fileList = this.state.fileList.map((oldFile, i) => {
                                if (oldFile.uid === file.uid) {
                                  oldFile.DocumentTypeId = value;
                                }
                                return oldFile;
                              })
                              this.setState({ fileList });
                            }}
                          >
                            {
                              this.state.componentDataSource.DocumentTypeId.map(option => <Select.Option style={{ color: option.Color }} key={option.Value} value={option.Value}>{option.Key}</Select.Option>)
                            }
                          </Select> : <span key="DocumentTypeId"></span>
                        }
                        <Input
                          className="filter-select footer-control"
                          style={{ width: '300px' }}
                          bordered={config.component.bordered}
                          maxLength={1000}
                          size={config.component.size}
                          placeholder="Comment"
                          onChange={(e) => {
                            let fileList = this.state.fileList.map((oldFile, i) => {
                              if (oldFile.uid === file.uid) {
                                oldFile.Comment = e.target.value;
                              }
                              return oldFile;
                            })
                            this.setState({ fileList });
                          }}
                        />
                      </span>
                    </div>
                    <div className="ant-upload-list-item-progress">
                      <div className="ant-progress ant-progress-line ant-progress-status-normal ant-progress-show-info ant-progress-default">
                        <Progress percent={globalFunction.formatPercent(file.percent)} strokeWidth={3} />
                      </div>
                    </div>
                  </div>
                  :
                  <div className='upload-container'>
                    <div className="ant-upload-list-item-info">
                      <span className="ant-upload-span" style={{ marginBottom: '4px' }}>
                        <span className="ant-upload-list-item-name ant-upload-list-item-error" title={file.tip}>{file.tip}</span>
                        <span className="ant-upload-list-item-card-actions">
                          <Tooltip title="Delete">
                            <Button
                              style={{ color: '#f5222d' }}
                              className="upload-delete-icon"
                              icon={<img className="svg-img-btn" src={'assets/images/icon/delete.svg'} />}
                              type='link'
                              onClick={() => {
                                this.removeFile(file);
                              }}
                            />
                          </Tooltip >
                        </span>
                      </span>
                    </div>
                  </div>
              }</>
            )}
          >
            <span style={{ display: 'contents' }}>Drag and Drop or <span className='link'>select file</span> to upload, Size limit: 100 MB. Photos will be resized to {config.uploadImageMaxLength}KB.</span>
          </Upload>
        </div>
      </AntDraggableModal>
    )
  }
}
